export default __webpack_public_path__ + "static/media/appBackground.31bbae53.jpg";